import { render, staticRenderFns } from "./ContentSidebarCustomer.vue?vue&type=template&id=5d83a148&"
import script from "./ContentSidebarCustomer.vue?vue&type=script&lang=js&"
export * from "./ContentSidebarCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ContentSidebarCustomer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports